// routes
import { paramCase } from 'change-case';
import { PATH_DEALER, PATH_COMMING, PATH_HelpAndCommunication } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';
import AppCache from '../../../services/appcache';
// -----------------------------------------------------------------------------------------------------------------

const icon = (name) => (
    <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
    dashboard: icon('ic_dashboard'),
    dataUpload: icon('ic_dataupload'),
    snsUpload: icon('ic_sns'),
    dataMapping: icon('ic_mapping'),
    myrequest: icon('ic_request'),
    manualdata: icon('ic_invoice'),
    helpdesk: icon('communication'),
    settings: icon('ic_settings'),
    calender: icon('ic_calender'),
    closuremonth: icon('ic_closuremonth'),
    report: icon('ic_chart'),
    data: icon('ic_data'),
};

const enableDataMode = AppCache.GetEnableDataMode();
const isHnCActive = AppCache?.GetCurrentLoggedInUser()?.IsHnCActive;

const userDetails = AppCache.GetUserLoginDetails();
const hasZylemFranchise = userDetails?.Franchise?.split(',')
    .some(f => f.trim().toUpperCase() === 'ETHICON' || f.trim().toUpperCase() === 'ENDO');

const navConfig = [
    {
        items: [
            { title: 'Dashboard', path: PATH_DEALER.dashboard, icon: ICONS.dashboard },
            { title: 'Data Upload', path: PATH_DEALER.dataUpload, icon: ICONS.dataUpload },
            { title: 'SNS Upload', path: PATH_DEALER.snsUpload, icon: ICONS.snsUpload },
            //  { title: 'Data Mapping', path: PATH_DEALER.dataMapping, icon: ICONS.dataMapping },
            //  { title: 'My Request', path: PATH_DEALER.myrequest, icon: ICONS.myrequest },
            ...(enableDataMode?.EnableOnlineEntry === 'True'
                ? [{ title: 'Online Entry', path: PATH_DEALER.manualdata, icon: ICONS.manualdata }]
                : []
            ),
            { title: 'Month Closure', path: PATH_DEALER.closuremonth, icon: ICONS.closuremonth },
            { title: 'JJ Connect', path: PATH_DEALER.jjconnectlink, icon: ICONS.dataMapping },
            { title: 'Help and Communication', path: PATH_HelpAndCommunication.helpandcommunication('JJ Core'), opneinnewtab: true, icon: ICONS.helpdesk },
            /*  ...(isHnCActive
                ? [{ title: 'Help And Communication', path: PATH_HelpAndCommunication.helpandcommunication('JJ CORE'), opneinnewtab: true, icon: ICONS.helpdesk }]
                : []
              ),    */
            {
                title: 'Data', path: PATH_DEALER.data.root, icon: ICONS.data,
                children: [
                    { title: 'Inventory', path: PATH_DEALER.data.inventorypage },
                    { title: 'Gross Sales', path: PATH_DEALER.data.grosssalepage },
                ],
            },
            {
                title: 'Report', path: PATH_DEALER.report.root, icon: ICONS.report,
                children: [
                    { title: 'Reported Sales', path: PATH_DEALER.report.transactionreportpage },
                    { title: 'Reported SNS', path: PATH_DEALER.report.dealerreportedsnsreportpage },
                    ...(hasZylemFranchise ? [
                        { title: 'Dealer Dump Report', path: PATH_DEALER.report.territorydumpreportpage },
                    ] : []),
                    // { title: 'Reported SNS', path: PATH_DEALER.report.dealersnsreportpage },
                    // { title: 'Gross Sales Report', path: PATH_DEALER.report.grosssalesreportpage },
                    //   { title: 'Dealer Price Report', path: PATH_DEALER.report.dealerreportpage },
                ],
            },
            // { title: 'Option 2', path: PATH_DEALER.onlineentrypage2, icon: ICONS.manualdata },
            // { title: 'Option 3', path: PATH_DEALER.onlineentrypage4, icon: ICONS.manualdata },
            // { title: 'Option 4', path: PATH_DEALER.onlineentry3, icon: ICONS.manualdata },
            // { title: 'Option 5', path: PATH_DEALER.onlineentry5, icon: ICONS.manualdata },
            //  { title: 'Calendar', path: PATH_DEALER.calender, icon: ICONS.calender },
            // { title: 'Helpdesk', path: PATH_COMMING.comming, icon: ICONS.helpdesk },
            //  { title: 'Settings', path: PATH_COMMING.comming, icon: ICONS.settings },
        ],
    }
];


export default navConfig;
